module.exports = __webpack_public_path__ + "img/specialpricepage-sample.e77af119.jpg";